/* eslint-disable camelcase */
import { AxiosRequestConfig } from 'axios';
import { archives, userService } from '@saucelabs/sl-util-axios';

import { Environment } from './types';

export interface GetTeamsParams {
  limit?: number;
  offset?: number;
}

export interface Team {
  id: string;
  name?: string;
}

export interface GetTeamsResponse {
  links: {
    next: string | null;
    previous: string | null;
    first: string | null;
    last: string | null;
  };
  results: Team[];
}

export interface GetUsersParams {
  username?: string;
  teams?: string;
  phrase?: string;
  roles?: string;
  team_name?: string;
  status?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export interface User {
  id: string;
  is_active?: boolean;
  username?: string;
}

export interface GetUsersResponse {
  links: {
    next: string | null;
    previous: string | null;
    first: string | null;
    last: string | null;
  };
  count: number;
  results: User[];
}

export function getUsers(params: GetUsersParams) {
  return userService.get<GetUsersResponse>(
    '/v1/users/',
    { params },
  );
}

export function getTeams(params: GetTeamsParams) {
  return userService.get<GetTeamsResponse>(
    '/v1/teams/',
    { params },
  );
}

export function getTeam(params: { id: string }) {
  return userService.get<Team>(
    `/v1/teams/${params.id}`,
  );
}

export function getUser(params: { id: string }) {
  return userService.get<User>(
    `/v1/users/${params.id}`,
  );
}

export interface GetFiltersParams {
  source: Environment;
  start_date?: number;
  end_date?: number;
  name?: string;
  name_match?: string;
}

export interface FilterResult {
  value: string;
  count: number;
}

export interface GetFiltersResponse {
  build_name: FilterResult[];
  device: FilterResult[];
  name: FilterResult[];
  os: {
    value: string;
    versions: FilterResult[];
  }[];
  browser: {
    value: string;
    versions: FilterResult[];
  }[];
  tag: FilterResult[];
}

export async function filtersSearch(config: AxiosRequestConfig) {
  const { params } = config;

  return archives.get<GetFiltersResponse>(
    '/filters',
    {
      ...config,
      params,
    },
  );
}

export interface SearchByFieldParams {
  field: 'build' | 'tag';
  phrase: string;

  start_date?: number;
  end_date?: number;
  owner_id?: string[];
  team_id?: string[];
  source?: Environment;
}

export interface SearchByFieldResponse {
  items: string[];
}

export async function searchByField(params: SearchByFieldParams) {
  const {
    field,
    ...rest
  } = params;

  return archives.get<SearchByFieldResponse>(
    `/list/names/${field}`,
    {
      params: {
        ...rest,
      },
    },
  );
}
